/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import * as plotDataActions from '../../../store/reducers/country/plot/data/actions';
import Dashboard from '../../../components/templates/Dashboard';
var actions = [plotDataActions];

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch: dispatch
  };
}

export default connect(null, mapDispatchToProps)(Dashboard);